/**
 * @file Custom-map.ts
 * @module CustomMap
 * @description Paplašināta OpenLayers Map klase ar renderēšanas biežuma ierobežojumu.
 *              Ierobežo render() metodi līdz konfigurējamam intervālam (noklusējums 125ms),
 *              lai novērstu pārmērīgu pārzīmēšanu ātru stāvokļa izmaiņu laikā
 *              (piem., daudzu slāņu redzamības pārslēgšana vai stilu atjauninājumi).
 */

import { Map, VectorRenderTile } from "ol";
import { getGroupEntities } from "../store/Layers.repository";

/**
 * Custom OpenLayers Map with base layer tile priority boosting.
 *
 * Overrides the default tile priority function to ensure base layer tiles
 * (identified by matching URLs from the layer store) are always loaded first
 * with priority 1. Other tiles use the default priority calculation.
 */
export class CustomMap extends Map {
	private func = new Map().getTilePriority;
	private URL_LIST: string[] = [];

	getTilePriority(tile: VectorRenderTile, tileSourceKey: any, tileCenter: any, tileResolution: any): any {
		if (this.URL_LIST.length === 0)
			getGroupEntities().subscribe((groups) => (this.URL_LIST = groups.find((g) => g.group === "base")?.layers.map((l) => (l as any).url) ?? []));

		if (this.URL_LIST.includes(tile.key)) {
			return 1;
		}

		return this.func(tile, tileSourceKey, tileCenter, tileResolution);
	}
}
